import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefresh = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_13994_127204",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 1,
			y: 1,
			width: 12,
			height: 12,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.368 2.706V4.76867H9.3059M11.0991 4.76867C10.3075 3.31792 8.76865 2.33325 6.99998 2.33325C4.42281 2.33325 2.33331 4.42275 2.33331 6.99992C2.33331 9.57708 4.42281 11.6666 6.99998 11.6666C9.57715 11.6666 11.6666 9.57708 11.6666 6.99992",
				stroke: "#323232",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("g", { mask: "url(#mask0_13994_127204)" }),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_13994_127204",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 1,
			y: 1,
			width: 12,
			height: 12,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M3.9375 4.8125H1.75V2.625M12.25 7C12.25 4.10025 9.89975 1.75 7 1.75C4.8825 1.75 3.06192 3.0065 2.23183 4.8125M10.0625 9.1875H12.25V11.375M1.75 7C1.75 9.89975 4.10025 12.25 7 12.25C9.1175 12.25 10.9381 10.9935 11.7682 9.1875",
				stroke: "#323232",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_13994_127204)",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgRefresh);
export default ForwardRef;
